export const visit = (vm, at) => {
vm(require("./availability/he-il.lyaml"));
vm(require("./typical-response-time/he-il.lyaml"));
vm(require("./default/he-il.lyaml"));
at({ "he-il": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "\u05D1\u05E1\u05D3\u05E8" } } });
};